import { ClientLocaleNS } from 'lib/constants/locales'

import commonJSON from './common.json'
import homePageJSON from './home_page.json'
import errorPageJSON from './error_page.json'
import refundPageJSON from './refund_page.json'
import termsPageJSON from './terms_page.json'
import privacyPageJSON from './privacy_page.json'
import cookiePageJSON from './cookie_page.json'
import productPageJSON from './product_page.json'
import checkoutPageJSON from './checkout_page.json'
import signUpPageJSON from './sign_up_page.json'
import profilePageJSON from './profile_page.json'
import aboutPageJSON from './about_page.json'

const resource = {
  [ClientLocaleNS.Common]: commonJSON,
  [ClientLocaleNS.HomePage]: homePageJSON,
  [ClientLocaleNS.ErrorPage]: errorPageJSON,
  [ClientLocaleNS.RefundPage]: refundPageJSON,
  [ClientLocaleNS.TermsPage]: termsPageJSON,
  [ClientLocaleNS.PrivacyPage]: privacyPageJSON,
  [ClientLocaleNS.CookiePage]: cookiePageJSON,
  [ClientLocaleNS.ProductPage]: productPageJSON,
  [ClientLocaleNS.CheckoutPage]: checkoutPageJSON,
  [ClientLocaleNS.SignUpPage]: signUpPageJSON,
  [ClientLocaleNS.ProfilePage]: profilePageJSON,
  [ClientLocaleNS.AboutPage]: aboutPageJSON,
}

export default resource
